import React from 'react';

const NuevaSolicitudDrodpdown = ({ id, className, items, selectedValue, changeFn }) => {
    return (
        <div className={className}>
            <select id={id} className="form-control default-select bottom-separator-xs error"
                onChange={(e) => changeFn(e)}
            >

                <option key={0}>Seleccione...</option>
                {items.map(item =>
                    item.nombre === selectedValue ?
                        <option key={item.id} selected>{item.nombre}</option> :
                        <option key={item.id}>{item.nombre}</option>)
                }

            </select>
        </div>
    );
}

export default NuevaSolicitudDrodpdown;
